import styles from "./DashboardPreview.module.css";

type PreviewStatus = "needs_attention" | "on_site" | "upcoming" | "completed";

interface PreviewShift {
  readonly status: PreviewStatus;
  readonly badge: string | null;
  readonly site: string;
  readonly cleaner: string;
  readonly initials: string;
  readonly time: string;
  readonly progress: number;
}

const PREVIEW_SHIFTS: readonly PreviewShift[] = [
  { status: "needs_attention", badge: "Late", site: "Kingsway Chambers", cleaner: "Lena Kowalski", initials: "LK", time: "7am - 9am", progress: 0 },
  { status: "on_site", badge: "On site", site: "Acme HQ", cleaner: "Maria Silva", initials: "MS", time: "8am - 10am", progress: 42 },
  { status: "upcoming", badge: null, site: "Barclays Tower", cleaner: "John Carter", initials: "JC", time: "10am - 12pm", progress: 0 },
  { status: "completed", badge: "Done", site: "Crown Offices", cleaner: "Sarah Khan", initials: "SK", time: "6am - 7am", progress: 100 },
];

export function DashboardPreview() {
  return (
    <section
      className={styles.wrapper}
      role="region"
      aria-label="Dashboard preview"
    >
      <div className={styles.header}>
        <span className={styles.label}>Preview</span>
        <span className={styles.hint}>
          Here's what your dashboard will show once cleaners are working.
        </span>
      </div>

      <div className={styles.tableCard}>
        <div className={`${styles.sectionLabel} ${styles.sectionLabelAlert}`}>
          Needs attention (1)
        </div>
        <PreviewRow shift={PREVIEW_SHIFTS[0]} />

        <div className={styles.sectionLabel}>On site (1)</div>
        <PreviewRow shift={PREVIEW_SHIFTS[1]} />

        <div className={styles.sectionLabel}>Upcoming (1)</div>
        <PreviewRow shift={PREVIEW_SHIFTS[2]} />

        <div className={styles.sectionLabel}>Completed (1)</div>
        <PreviewRow shift={PREVIEW_SHIFTS[3]} />
      </div>
    </section>
  );
}

function PreviewRow({ shift }: { readonly shift: PreviewShift }) {
  const badgeClass =
    shift.status === "needs_attention"
      ? styles.badgeWarning
      : shift.status === "on_site"
        ? styles.badgeSuccess
        : shift.status === "completed"
          ? styles.badgeNeutral
          : styles.badgeGhost;

  const stripClass =
    shift.status === "needs_attention" ? styles.stripWarning : "";

  return (
    <div className={styles.row}>
      {stripClass && <span className={`${styles.strip} ${stripClass}`} aria-hidden="true" />}
      <div className={styles.statusCell}>
        {shift.badge && <span className={`${styles.badge} ${badgeClass}`}>{shift.badge}</span>}
      </div>
      <div className={styles.siteCell}>{shift.site}</div>
      <div className={styles.cleanerCell}>
        <span className={styles.avatar}>{shift.initials}</span>
        <span>{shift.cleaner}</span>
      </div>
      <div className={styles.timeCell}>{shift.time}</div>
      <div className={styles.progressCell}>
        {shift.status === "needs_attention" ? (
          <span className={styles.notCheckedIn}>Not checked in</span>
        ) : (
          <div className={styles.progressBar}>
            <div
              className={
                shift.status === "on_site"
                  ? `${styles.progressFill} ${styles.progressLive}`
                  : `${styles.progressFill} ${styles.progressDone}`
              }
              style={
                shift.status === "on_site"
                  ? undefined
                  : { width: `${shift.progress}%` }
              }
            />
          </div>
        )}

      </div>
    </div>
  );
}
